export default "__VITE_ASSET__isWG9_P9__"